import React from 'react';
import { Layout, Menu, Select } from 'antd';
import { Link } from 'react-router-dom';
import ToolBar from './ToolBar/ToolBar';
import logo from '../../../assets/img/header-logo2.png';
import s from './style.less';
import Search from './Search';
import TopBar from '../TopBar/TopBar';


const { Header } = Layout;

class HeaderBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      history: props.history || {},
    };
  }

  handleClick(item) {
    const currentFullPath = item.key;
    let redirectFullPath;

    if (currentFullPath === '/marketing') {
      window.open('https://www.99bill.com/seashell/webapp/ms/');
      return;
    }

    if (currentFullPath === '/helpCenter') {
      // window.open('https://help.99bill.com/index.php/qiye.html');
      window.open('https://help.99bill.com/index.php/newwebsite.html');
      return;
    }

    this.props.menuList.forEach((ele, idx) => {
      if (ele.currentFullPath === currentFullPath) {
        redirectFullPath = ele.redirectFullPath;
        this.props.onClick(currentFullPath, idx);
      }
    });

    if (this.props.history.location.pathname !== redirectFullPath) {
      this.state.history.push(redirectFullPath);
    }
  }

  render() {
    const selectedKeys = [`/${this.props.history.location.pathname.split('/')[1]}`];

    const menuList = this.props.menuList || [];
    const { isHeaderFixed } = this.props;

    return (
      <div className={s.headerWrap}>
        <TopBar />
        <div className={isHeaderFixed ? s.pos : null}>
          {/* <div className={s.pos}> */}
          <Header className={`${s.wrap} headerBar`}>
            <div>
              <a
                href={`${location.pathname}`}
                className={s.logo}
              >
                <img src={logo} alt="logo" height={40} width={40} />
                <span>商户管理平台</span>
              </a>
              <Menu
                mode="horizontal"
                selectedKeys={selectedKeys}
                className={s.menu}
                onClick={(item, i) => this.handleClick(item)}
              >
                {menuList.map((menu) => {
                  // const key = `/${menu.path.split('/')[1]}`;
                  return (
                    <Menu.Item className={s.menuItem} key={menu.currentFullPath}>{menu.name}</Menu.Item>
                  );
                })}
                <Menu.Item className={s.menuItem} key="/helpCenter">帮助中心</Menu.Item>
              </Menu>
              <div style={{ float: 'right' }}>
                <Search />
              </div>
            </div>
          </Header>
        </div>
        {
          isHeaderFixed ? <div style={{ height: '64px' }}></div> : null
        }
        {/* <div style={{ height: '95px' }}></div> */}
      </div>
    );
  }
}

export default HeaderBar;



// WEBPACK FOOTER //
// ./src/views/MainLayout/HeaderBar/HeaderBar.jsx